import { BasePageComponent } from "@/components/base/BasePageComponent";
import { BreadcrumbItem } from "@/components/breadcrumb/breadcrumb.component";
import { CertificationHelper } from "@/helpers/certification.helper";
import { PropertyHelper } from "@/helpers/property.helper";
import { UserHelper } from "@/helpers/user.helper";
import { AlertService } from "@/services/alert.service";
import { AppConfigService } from "@/services/app-config.service";
import { NavService } from "@/services/nav.service";
import { NgFor, NgIf } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialog } from "@angular/material/dialog";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
} from "@angular/router";
import {
  ActionState,
  CertificationRequest,
  CertificationsService,
  Document,
  PropertiesService,
  PropertyCategory,
  PropertyOpenDataDpe,
  RealProperty,
  SharingDataCategory,
  SharingService,
  SharingVisitModeType,
  VaultService,
} from "@eemo/api-client";
import { Subscription } from "rxjs";
import { BreadcrumbComponent } from "../../../components/breadcrumb/breadcrumb.component";
import { PropertyProfilComponent } from "../../../components/property-profil/property-profil.component";
import { FileSizePipe } from "../../../extensions/fileSizePipe";
import { PropertyPhotosComponent } from "../property-photos/property-photos.component";

import { ConfirmDialogComponent } from "@/components/confirm-dialog/confirm-dialog.component";
import { DataLoadingComponent } from "@/components/data-loading/data-loading.component";
import { PropertyDpeChoiceDialogComponent } from "@/components/property-dpe-choice-dialog/property-dpe-choice-dialog.component";
import { ActionDoneType } from "@/enums/ActionDoneType.enum";
import { ObjectUpdatedType } from "@/enums/ObjectUpdatedType.enum";
import { ActionService } from "@/services/action.service";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { environment } from "src/environments/environment";
import { FloatMenuComponent } from "../../../components/float-menu/float-menu.component";

@Component({
  selector: "app-property",
  templateUrl: "./property.component.html",
  styleUrls: ["./property.component.scss"],
  standalone: true,
  imports: [
    NgIf,
    FloatMenuComponent,
    MatButtonModule,
    RouterLink,
    MatIconModule,
    MatMenuModule,
    BreadcrumbComponent,
    PropertyPhotosComponent,
    PropertyProfilComponent,
    RouterOutlet,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    NgFor,
    MatProgressSpinnerModule,
    FileSizePipe,
    DataLoadingComponent,
  ],
})
export class PropertyComponent
  extends BasePageComponent
  implements OnInit, OnDestroy
{
  @ViewChild("slideShow") photoSlideShowComponent: PropertyPhotosComponent;

  loading = true;

  currentComponent: any;

  propId: string;
  prop: RealProperty;
  certificationRequest: CertificationRequest;
  certificationRequestStatusName: string;
  headerContentbackLink: string;
  headerContentTitle: string;
  propIdIsEemoId = false;

  accessDenied = false;
  requestAccessMessage: string;

  visitAcknowledgementRequired = false;
  visitModeTypeFull = true;
  visitRealtorName: string;
  docsToValidate: Document[] = [];
  // we need to manually manage the form validation as the checkboxes for docs
  // are disabled by default and angular form do not include disabled field
  formVisitModeValid = false;

  titleClass = "title-normal";

  canShowPropertyServiceBtnAdd = false;
  canShowPropertySaleBtnAdd = false;
  canUpdateProperty = false;
  canUpdatePropertyNotes = false;
  canAddShare = false;
  canRequestCertification = false;
  canArchiveProperty = false;
  canDeleteProperty = false;
  canTransferProperty = false;
  canCertifyProperty = false;
  isCertificationRequestOnGoing = false;
  canShowPropertyDataSync = false;
  canAddDpeNumber = false;
  canViewPhoto = false;

  isMobileApp = false;

  isSharedProperty = false;

  openDataSyncInProgress = false;
  openDataSyncDone = false;

  subs: Subscription[] = [];

  timer: NodeJS.Timeout;

  formSubmitting = false;
  formVisitMode = this.fb.group({
    visitChecked: [false, Validators.requiredTrue],
    validatedDocs: this.fb.array([]),
  });

  get form_validatedDocs() {
    return this.formVisitMode.get("validatedDocs") as UntypedFormArray;
  }

  get form_visitChecked() {
    return this.formVisitMode.get("visitChecked") as FormControl<boolean>;
  }

  addValidateDocFormControl(doc: Document) {
    const control = new FormControl<boolean>(false, Validators.requiredTrue);
    control.disable();
    this.form_validatedDocs.push(control);
  }

  checkFormValid() {
    // main visit
    this.formVisitModeValid = this.formVisitMode.valid;
    // full
    if (this.visitModeTypeFull && this.formVisitModeValid) {
      for (let i = 0; i < this.form_validatedDocs.length; i++) {
        if (this.form_validatedDocs.at(i).disabled) {
          this.formVisitModeValid = false;
          break;
        }
      }
    }
  }

  constructor(
    protected route: ActivatedRoute,
    private router: Router,
    private propertyService: PropertiesService,
    private alertService: AlertService,
    public propHelper: PropertyHelper,
    public userHelper: UserHelper,
    private dialog: MatDialog,
    private certificationService: CertificationsService,
    private sharingService: SharingService,
    public certificationHelper: CertificationHelper,
    private propertiesService: PropertiesService,
    private appConfigService: AppConfigService,
    protected navService: NavService,
    private ref: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private vaultService: VaultService,
    public actionService: ActionService
  ) {
    super(route, navService);
    this.isMobileApp = appConfigService.isMobileApp;
  }

  ngOnInit() {
    this.subs.push(
      this.actionService.showPhotosTriggered$.subscribe((show) => {
        if (show) {
          this.showPhotos();
        }
      })
    );
    this.subs.push(
      this.route.paramMap.subscribe((paramMap) => {
        this.navService.onNavUidEvent(paramMap.get("uid") || null);
      })
    );

    this.route.paramMap.subscribe((params) => {
      const uid = params.get("uid");
      if (!uid) {
        this.alertService.error("Paramètres invalides");
        return;
      }
      this.propId = uid;
      if (
        uid.match("^[A-Z]{2}[0-9]{2}-[A-Z]{1}[A-Z0-9]{1}[0-9]{2}-[A-Z0-9]{4}$")
      ) {
        // the eemoId is provided
        this.propIdIsEemoId = true;
        this.subs.push(
          this.propertyService.getRealPropertyByEemoId(uid).subscribe({
            next: (prop) => {
              //replace the current url with the uid
              this.router.navigate(["/property/" + prop.uid]);
            },
            error: (err: HttpErrorResponse) => {
              this.loading = false;
              if (err.status === 403) {
                this.accessDenied = true;
              } else if (err.status === 404) {
                this.alertService.warning("Aucun bien trouvé pour cet EEMO ID");
                this.router.navigate(["/home"]);
              }
            },
          })
        );
        return;
      }
      //uid provided
      this.subs.push(
        this.propertyService.getRealProperty(uid).subscribe({
          next: (result) => {
            if (result.deleted) {
              this.loading = false;
              this.alertService.warning("Ce bien a été supprimé");
              this.router.navigate(["/home"]);
            }
            this.loadProperty(result);
            // manage visit feedback direct access
            const sharingUid = params.get("sharingUid");
            this.manageSharingFeedbackDirectAccess(sharingUid);
          },
          error: (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.status === 403) {
              this.accessDenied = true;
            } else if (err.status === 404) {
              this.alertService.warning("Aucun bien trouvé pour ce lien");
              this.router.navigate(["/home"]);
            }
          },
        })
      );
    });

    this.subs.push(
      this.appConfigService.objectUpdated.subscribe((type) => {
        this.reloadProperty();
        switch (type) {
          case ObjectUpdatedType.PHOTO:
            this.photoSlideShowComponent.refreshPhotoList();
            break;
        }
      })
    );

    this.subs.push(
      this.appConfigService.actionDone.subscribe((type) => {
        switch (type) {
          case ActionDoneType.CERTIFY_REQUEST:
            this.loadCertificationRequest();
            break;
        }
      })
    );

    this.subs.push(
      this.appConfigService.actionDone.subscribe((a) => {
        if (a === ActionDoneType.OPENDATA_SYNC) {
          // wait 2 seconds for the sync to start
          setTimeout(() => this.checkOpenDataStatusInProgress(), 2000);
        }
      })
    );

    this.subs.push(
      this.formVisitMode.valueChanges.subscribe(() => this.checkFormValid())
    );
  }

  manageSharingFeedbackDirectAccess(sharingUid: string) {
    if (sharingUid) {
      if (this.prop.details.accessSharing.hasFeedback) {
        this.alertService.warning("Le rapport de visite a déjà été rempli");
      } else if (!this.prop.onGoingSelling) {
        this.alertService.warning(
          "L'accès au rapport de visite n'est plus valide, le bien n'est plus à vendre"
        );
      } else if (
        !this.canUpdateProperty &&
        this.prop.details.accessSharing.uid !== sharingUid
      ) {
        this.alertService.warning(
          "Vous n'êtes pas autorisé à accéder à ce rapport de visite"
        );
      } else {
        // param provided by direct feedback route -> show feedback dialog
        this.actionService.addVisitFeedback(sharingUid);
      }
      //redirect to property home
      this.router.navigate(["property", this.propId]);
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
    this.navService.currentDataPage$.next(null);

    this.stopOpenDataStatusAutoRefresh();
  }

  checkOpenDataStatusInProgress() {
    //check open daata status
    if (this.canShowPropertyDataSync) {
      this.subs.push(
        this.propertiesService
          .getRealPropertyOpenDataStatus(this.prop.uid)
          .subscribe((s) => {
            const status = s.find(() => true);
            if (status?.state === ActionState.IN_PROGRESS) {
              this.openDataSyncInProgress = true;
              this.startOpenDataStatusAutoRefresh();
            }
          })
      );
    }
  }

  checkOpenDataStatusDone() {
    //check open daata status
    if (this.canShowPropertyDataSync) {
      this.subs.push(
        this.propertiesService
          .getRealPropertyOpenDataStatus(this.prop.uid)
          .subscribe((s) => {
            const status = s.find(() => true);
            if (status?.state !== ActionState.IN_PROGRESS) {
              this.openDataSyncInProgress = false;
              this.openDataSyncDone = true;
              this.stopOpenDataStatusAutoRefresh();
            }
          })
      );
    }
  }

  checkCanAddDpeNumber() {
    if (this.canShowPropertyDataSync) {
      this.subs.push(
        this.propertiesService
          .getRealPropertyAttributes(this.propId, PropertyCategory.ENERGY)
          .subscribe((attrs) => {
            this.canAddDpeNumber =
              attrs.filter((a) => a.code === environment.DPE_ATTRIBUTE_NUMBER)
                .length === 0;
          })
      );
    }
  }

  startOpenDataStatusAutoRefresh() {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.checkOpenDataStatusDone(), 10000);
  }

  stopOpenDataStatusAutoRefresh() {
    clearInterval(this.timer);
  }

  reload() {
    this.actionService.reloadPage();
  }

  checkDpeAvailable() {
    // check if there is dpe available
    if (this.canShowPropertyDataSync) {
      this.subs.push(
        this.propertiesService
          .getRealPropertyOpenDataAvailableDpe(this.prop.uid)
          .subscribe((dpeList) => {
            if (dpeList.length > 0) {
              this.showDpeChoiceDialog(dpeList);
            }
          })
      );
    }
  }
  showDpeChoiceDialog(dpeList: PropertyOpenDataDpe[]) {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      this.dialog.open(PropertyDpeChoiceDialogComponent, {
        // width: '25rem',
        data: {
          property: this.prop,
          dpeList,
        },
      });
    }
  }

  registerCurrentComponent(componentRef: any) {
    this.currentComponent = componentRef;
  }

  onActivate(event: any) {
    this.registerCurrentComponent(event);
  }

  private reloadProperty() {
    this.subs.push(
      this.propertiesService.getRealProperty(this.prop.uid).subscribe((p) => {
        this.loadProperty(p);
        this.appConfigService.selectedProp = p;
      })
    );
  }

  private loadProperty(prop: RealProperty) {
    this.propId = prop.uid;
    this.prop = prop;
    this.canViewPhoto = this.userHelper.canViewCategory(
      prop,
      SharingDataCategory.PHOTO
    );
    this.isSharedProperty = !this.userHelper.isPropertyOwner(prop);
    this.canShowPropertyServiceBtnAdd =
      this.userHelper.canManagePropertyService(prop);
    this.canShowPropertySaleBtnAdd = this.userHelper.canAddPropertySale(prop);
    this.canUpdateProperty = this.userHelper.canUpdateProperty(prop);
    this.canAddShare =
      this.canUpdateProperty && prop.certified && !prop.archived;
    this.canArchiveProperty = this.userHelper.canArchiveProperty(prop);
    this.canDeleteProperty = this.userHelper.canDeleteProperty(prop);
    this.canTransferProperty =
      !prop.archived && this.userHelper.canTransfertProperty(prop);
    this.canCertifyProperty =
      !prop.archived && this.userHelper.canCertifyProperty(prop);
    this.canShowPropertyDataSync =
      this.userHelper.canViewPropertyDataSync(prop);
    this.canUpdatePropertyNotes =
      this.userHelper.isAdmin() || this.userHelper.isPropertyOwner(prop);

    this.appConfigService.selectedProp = this.prop;
    this.updateTitleClass();
    this.loadCertificationRequest();
    this.checkOpenDataStatusInProgress();
    this.checkDpeAvailable();
    this.checkCanAddDpeNumber();
    this.visitAcknowledgementRequired =
      prop.details?.accessSharing?.visitMode &&
      !prop.details?.accessSharing?.visitAcknowledged;
    this.visitModeTypeFull =
      prop.details?.accessSharing?.visitModeType === SharingVisitModeType.FULL;
    if (this.visitAcknowledgementRequired) {
      //disable float menu
      this.appConfigService.floatMenuEnabled = false;
      this.visitRealtorName = UserHelper.userSummmaryDisplayName(
        prop.details.sharingUser
      );
      //get docs to validate
      this.subs.push(
        this.sharingService
          .getSharingVisitDocs(prop.details.accessSharing.uid)
          .subscribe((docs) => {
            docs.forEach((d) => {
              this.docsToValidate.push(d);
              this.addValidateDocFormControl(d);
            });
          })
      );
    } else {
      //enable float menu
      this.appConfigService.floatMenuEnabled = true;
    }
    this.loading = false;
  }

  loadCertificationRequest() {
    // TODO manage pagination
    this.subs.push(
      this.certificationService.getCertificationRequests().subscribe((data) => {
        const requests = data.list.filter(
          (request) => request.property.uid === this.prop.uid
        );
        if (requests.length > 0) {
          this.certificationRequest = requests[0];
          this.appConfigService.selectedPropCertificationRequest =
            this.certificationRequest;
          this.isCertificationRequestOnGoing =
            CertificationHelper.isOnGoingCertificationRequest(
              this.certificationRequest
            );
          this.certificationRequestStatusName =
            this.certificationHelper.getCertificationsRequestStatusName(
              this.certificationRequest.status
            );
        }

        this.canRequestCertification =
          this.canUpdateProperty &&
          !this.canCertifyProperty &&
          !this.prop.certified &&
          !this.prop.archived &&
          !this.isCertificationRequestOnGoing;
      })
    );
  }

  onSubmit() {
    this.formSubmitting = true;
    this.checkFormValid();
    if (!this.formVisitModeValid) return;

    this.subs.push(
      this.sharingService
        .acknowledgeSharingVisit(this.prop.details.accessSharing.uid, {
          validatedDocs: this.docsToValidate.map((d) => d.uid),
        })
        .subscribe(() => {
          this.alertService.success(
            "Merci pour votre validation. Vous avez maintenant accès aux données du bien !"
          );
          this.formSubmitting = false;
          this.reloadProperty();
        })
    );
  }

  updateTitleClass() {
    if (this.prop.name.length > 30) {
      this.titleClass = "title-small";
    } else {
      this.titleClass = "title-normal";
    }
  }

  onNewBreadcrumb(list: BreadcrumbItem[]) {
    this.headerContentbackLink = list[list.length - 2]?.link || null;
    this.headerContentTitle = list[list.length - 1]?.text || null;
    this.ref.detectChanges();
  }

  docCheckboxOnClick(index) {
    // if the control is disabled (doc not validated), we show the doc
    if (!this.form_validatedDocs.at(index).enabled) {
      this.viewDoc(index);
    }
  }

  confirmRequestAccess() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message: "Confirmez-vous la demande d'accès au bien ?",
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.doRequestAccess();
        }
      });
    }
  }

  doRequestAccess() {
    const requestObs = this.propIdIsEemoId
      ? this.sharingService.requestSharingByEemoId(this.propId, {
          message: this.requestAccessMessage,
        })
      : this.sharingService.requestSharing(this.propId, {
          message: this.requestAccessMessage,
        });
    this.subs.push(
      requestObs.subscribe(() => {
        this.alertService.success("Demande d'accès envoyée");
        this.router.navigate(["/home"]);
      })
    );
  }

  showPhotos() {
    if (this.photoSlideShowComponent.hasPhoto) {
      this.photoSlideShowComponent.showImage(null);
    }
  }

  viewDoc(index) {
    const doc = this.docsToValidate[index];
    this.form_validatedDocs.at(index).enable();
    this.checkFormValid();
    this.subs.push(
      this.actionService.viewDoc(doc, true).subscribe((result) => {
        if (result) {
          this.form_validatedDocs.at(index).setValue(true);
        }
      })
    );
  }

  togglePropertyArchive() {
    this.actionService.togglePropertyArchive(this.prop);
  }
}
